import React from 'react';
import {
  AdvancedSetting,
  SettingsGroup,
} from 'api/advanced-settings/settings-types';
import { ReactComponent as StatusChangeIcon } from 'assets/svgs/status-change.svg';
import { useTranslation } from 'hooks/use-translation';
import { SettingGroup } from '../common';
import { SettingHeader } from '../common/setting-header';

export const StatusAutomation = ({
  settingsConfig,
  onSettingChange,
}: {
  settingsConfig: AdvancedSetting[];
  onSettingChange: (value: AdvancedSetting) => void;
}) => {
  const title = useTranslation('settings.advanced.status_automation.title');

  return (
    <>
      <SettingHeader title={title} icon={<StatusChangeIcon fill="black" />} />
      <SettingGroup
        title="Tasks"
        groupType={SettingsGroup.TaskStatusAutomation}
        settingsConfig={settingsConfig}
        onSettingChange={onSettingChange}
      />
    </>
  );
};
